export interface Country {
  label: string;
  value: string;
  flag: string;
  country: string;
  mask?: string;
  maskLength?: number;
  length?: number;
}

export const getCountries = (): Array<Country> => {
  return [
    {
      label: '+1',
      value: '1',
      flag: '🇺🇸',
      country: 'Estados Unidos',
      mask: '(___)___-____',
      length: 10,
      maskLength: 3,
    },
    {
      label: '+93',
      value: '93',
      flag: '🇦🇫',
      country: 'Afeganistão',
    },
    {
      label: '+355',
      value: '355',
      flag: '🇦🇱',
      country: 'Albânia',
    },
    {
      label: '+213',
      value: '213',
      flag: '🇩🇿',
      country: 'Argélia',
    },
    {
      label: '+1-684',
      value: '1684',
      flag: '🇦🇸',
      country: 'Samoa Americana',
    },
    {
      label: '+376',
      value: '376',
      flag: '🇦🇩',
      country: 'Andorra',
    },
    {
      label: '+244',
      value: '244',
      flag: '🇦🇴',
      country: 'Angola',
    },
    {
      label: '+1-264',
      value: '1264',
      flag: '🇦🇮',
      country: 'Anguilla',
    },
    {
      label: '+672',
      value: '672',
      flag: '🇦🇶',
      country: 'Antártida',
    },
    {
      label: '+1-268',
      value: '1268',
      flag: '🇦🇬',
      country: 'Antígua e Barbuda',
    },
    {
      label: '+54',
      value: '54',
      flag: '🇦🇷',
      country: 'Argentina',
    },
    {
      label: '+374',
      value: '374',
      flag: '🇦🇲',
      country: 'Armênia',
    },
    {
      label: '+297',
      value: '297',
      flag: '🇦🇼',
      country: 'Aruba',
    },
    {
      label: '+61',
      value: '61',
      flag: '🇦🇺',
      country: 'Austrália',
    },
    {
      label: '+43',
      value: '43',
      flag: '🇦🇹',
      country: 'Áustria',
    },
    {
      label: '+994',
      value: '994',
      flag: '🇦🇿',
      country: 'Azerbaijão',
    },
    {
      label: '+1-242',
      value: '1242',
      flag: '🇧🇸',
      country: 'Bahamas',
    },
    {
      label: '+973',
      value: '973',
      flag: '🇧🇭',
      country: 'Bahrein',
    },
    {
      label: '+880',
      value: '880',
      flag: '🇧🇩',
      country: 'Bangladesh',
    },
    {
      label: '+1-246',
      value: '1246',
      flag: '🇧🇧',
      country: 'Barbados',
    },
    {
      label: '+375',
      value: '375',
      flag: '🇧🇾',
      country: 'Bielorrússia',
    },
    {
      label: '+32',
      value: '32',
      flag: '🇧🇪',
      country: 'Bélgica',
    },
    {
      label: '+501',
      value: '501',
      flag: '🇧🇿',
      country: 'Belize',
    },
    {
      label: '+229',
      value: '229',
      flag: '🇧🇯',
      country: 'Benin',
    },
    {
      label: '+1-441',
      value: '1441',
      flag: '🇧🇲',
      country: 'Bermudas',
    },
    {
      label: '+975',
      value: '975',
      flag: '🇧🇹',
      country: 'Butão',
    },
    {
      label: '+591',
      value: '591',
      flag: '🇧🇴',
      country: 'Bolívia',
    },
    {
      label: '+387',
      value: '387',
      flag: '🇧🇦',
      country: 'Bósnia e Herzegovina',
    },
    {
      label: '+267',
      value: '267',
      flag: '🇧🇼',
      country: 'Botsuana',
    },
    {
      label: '+55',
      value: '55',
      flag: '🇧🇷',
      country: 'Brasil',
      mask: '(__)_____-____',
      length: 11,
      maskLength: 3,
    },
    {
      label: '+246',
      value: '246',
      flag: '🇮🇴',
      country: 'Território Britânico do Oceano Índico',
    },
    {
      label: '+1-284',
      value: '1284',
      flag: '🇻🇬',
      country: 'Ilhas Virgens Britânicas',
    },
    {
      label: '+673',
      value: '673',
      flag: '🇧🇳',
      country: 'Brunei',
    },
    {
      label: '+359',
      value: '359',
      flag: '🇧🇬',
      country: 'Bulgária',
    },
    {
      label: '+226',
      value: '226',
      flag: '🇧🇫',
      country: 'Burquina Faso',
    },
    {
      label: '+257',
      value: '257',
      flag: '🇧🇮',
      country: 'Burundi',
    },
    {
      label: '+855',
      value: '855',
      flag: '🇰🇭',
      country: 'Camboja',
    },
    {
      label: '+237',
      value: '237',
      flag: '🇨🇲',
      country: 'Camarões',
    },
    {
      label: '+1',
      value: '1',
      flag: '🇨🇦',
      country: 'Canadá',
    },
    {
      label: '+238',
      value: '238',
      flag: '🇨🇻',
      country: 'Cabo Verde',
    },
    {
      label: '+1-345',
      value: '1345',
      flag: '🇰🇾',
      country: 'Ilhas Cayman',
    },
    {
      label: '+236',
      value: '236',
      flag: '🇨🇫',
      country: 'República Centro-Africana',
    },
    {
      label: '+235',
      value: '235',
      flag: '🇹🇩',
      country: 'Chade',
    },
    {
      label: '+56',
      value: '56',
      flag: '🇨🇱',
      country: 'Chile',
    },
    {
      label: '+86',
      value: '86',
      flag: '🇨🇳',
      country: 'China',
    },
    {
      label: '+61',
      value: '61',
      flag: '🇨🇽',
      country: 'Ilhas Natal',
    },
    {
      label: '+61',
      value: '61',
      flag: '🇨🇨',
      country: 'Ilhas Cocos (Keeling)',
    },
    {
      label: '+57',
      value: '57',
      flag: '🇨🇴',
      country: 'Colômbia',
    },
    {
      label: '+269',
      value: '269',
      flag: '🇰🇲',
      country: 'Comores',
    },
    {
      label: '+682',
      value: '682',
      flag: '🇨🇰',
      country: 'Ilhas Cook',
    },
    {
      label: '+506',
      value: '506',
      flag: '🇨🇷',
      country: 'Costa Rica',
    },
    {
      label: '+385',
      value: '385',
      flag: '🇭🇷',
      country: 'Croácia',
    },
    {
      label: '+53',
      value: '53',
      flag: '🇨🇺',
      country: 'Cuba',
    },
    {
      label: '+599',
      value: '599',
      flag: '🇨🇼',
      country: 'Curaçao',
    },
    {
      label: '+357',
      value: '357',
      flag: '🇨🇾',
      country: 'Chipre',
    },
    {
      label: '+420',
      value: '420',
      flag: '🇨🇿',
      country: 'República Tcheca',
    },
    {
      label: '+243',
      value: '243',
      flag: '🇨🇩',
      country: 'República Democrática do Congo',
    },
    {
      label: '+45',
      value: '45',
      flag: '🇩🇰',
      country: 'Dinamarca',
    },
    {
      label: '+253',
      value: '253',
      flag: '🇩🇯',
      country: 'Djibuti',
    },
    {
      label: '+1-767',
      value: '1767',
      flag: '🇩🇲',
      country: 'Dominica',
    },
    {
      label: '+1-809',
      value: '1809',
      flag: '🇩🇴',
      country: 'República Dominicana',
    },
    {
      label: '+593',
      value: '593',
      flag: '🇪🇨',
      country: 'Equador',
    },
    {
      label: '+20',
      value: '20',
      flag: '🇪🇬',
      country: 'Egito',
    },
    {
      label: '+503',
      value: '503',
      flag: '🇸🇻',
      country: 'El Salvador',
    },
    {
      label: '+240',
      value: '240',
      flag: '🇬🇶',
      country: 'Guiné Equatorial',
    },
    {
      label: '+291',
      value: '291',
      flag: '🇪🇷',
      country: 'Eritreia',
    },
    {
      label: '+372',
      value: '372',
      flag: '🇪🇪',
      country: 'Estônia',
    },
    {
      label: '+268',
      value: '268',
      flag: '🇸🇿',
      country: 'Essuatíni',
    },
    {
      label: '+251',
      value: '251',
      flag: '🇪🇹',
      country: 'Etiópia',
    },
    {
      label: '+500',
      value: '500',
      flag: '🇫🇰',
      country: 'Ilhas Malvinas',
    },
    {
      label: '+298',
      value: '298',
      flag: '🇫🇴',
      country: 'Ilhas Faroé',
    },
    {
      label: '+679',
      value: '679',
      flag: '🇫🇯',
      country: 'Fiji',
    },
    {
      label: '+358',
      value: '358',
      flag: '🇫🇮',
      country: 'Finlândia',
    },
    {
      label: '+33',
      value: '33',
      flag: '🇫🇷',
      country: 'França',
    },
    {
      label: '+594',
      value: '594',
      flag: '🇬🇫',
      country: 'Guiana Francesa',
    },
    {
      label: '+689',
      value: '689',
      flag: '🇵🇫',
      country: 'Polinésia Francesa',
    },
    {
      label: '+241',
      value: '241',
      flag: '🇬🇦',
      country: 'Gabão',
    },
    {
      label: '+220',
      value: '220',
      flag: '🇬🇲',
      country: 'Gâmbia',
    },
    {
      label: '+995',
      value: '995',
      flag: '🇬🇪',
      country: 'Geórgia',
    },
    {
      label: '+49',
      value: '49',
      flag: '🇩🇪',
      country: 'Alemanha',
    },
    {
      label: '+233',
      value: '233',
      flag: '🇬🇭',
      country: 'Gana',
    },
    {
      label: '+350',
      value: '350',
      flag: '🇬🇮',
      country: 'Gibraltar',
    },
    {
      label: '+30',
      value: '30',
      flag: '🇬🇷',
      country: 'Grécia',
    },
    {
      label: '+299',
      value: '299',
      flag: '🇬🇱',
      country: 'Groenlândia',
    },
    {
      label: '+1-473',
      value: '1473',
      flag: '🇬🇩',
      country: 'Granada',
    },
    {
      label: '+590',
      value: '590',
      flag: '🇬🇵',
      country: 'Guadalupe',
    },
    {
      label: '+1-671',
      value: '1671',
      flag: '🇬🇺',
      country: 'Guam',
    },
    {
      label: '+502',
      value: '502',
      flag: '🇬🇹',
      country: 'Guatemala',
    },
    {
      label: '+44-1481',
      value: '441481',
      flag: '🇬🇬',
      country: 'Guernsey',
    },
    {
      label: '+224',
      value: '224',
      flag: '🇬🇳',
      country: 'Guiné',
    },
    {
      label: '+245',
      value: '245',
      flag: '🇬🇼',
      country: 'Guiné-Bissau',
    },
    {
      label: '+592',
      value: '592',
      flag: '🇬🇾',
      country: 'Guiana',
    },
    {
      label: '+509',
      value: '509',
      flag: '🇭🇹',
      country: 'Haiti',
    },
    {
      label: '+504',
      value: '504',
      flag: '🇭🇳',
      country: 'Honduras',
    },
    {
      label: '+852',
      value: '852',
      flag: '🇭🇰',
      country: 'Hong Kong',
    },
    {
      label: '+36',
      value: '36',
      flag: '🇭🇺',
      country: 'Hungria',
    },
    {
      label: '+354',
      value: '354',
      flag: '🇮🇸',
      country: 'Islândia',
    },
    {
      label: '+91',
      value: '91',
      flag: '🇮🇳',
      country: 'Índia',
    },
    {
      label: '+62',
      value: '62',
      flag: '🇮🇩',
      country: 'Indonésia',
    },
    {
      label: '+98',
      value: '98',
      flag: '🇮🇷',
      country: 'Irã',
    },
    {
      label: '+964',
      value: '964',
      flag: '🇮🇶',
      country: 'Iraque',
    },
    {
      label: '+353',
      value: '353',
      flag: '🇮🇪',
      country: 'Irlanda',
    },
    {
      label: '+44-1624',
      value: '441624',
      flag: '🇮🇲',
      country: 'Ilha de Man',
    },
    {
      label: '+972',
      value: '972',
      flag: '🇮🇱',
      country: 'Israel',
    },
    {
      label: '+39',
      value: '39',
      flag: '🇮🇹',
      country: 'Itália',
    },
    {
      label: '+225',
      value: '225',
      flag: '🇨🇮',
      country: 'Costa do Marfim',
    },
    {
      label: '+1-876',
      value: '1876',
      flag: '🇯🇲',
      country: 'Jamaica',
    },
    {
      label: '+81',
      value: '81',
      flag: '🇯🇵',
      country: 'Japão',
    },
    {
      label: '+44-1534',
      value: '441534',
      flag: '🇯🇪',
      country: 'Jersey',
    },
    {
      label: '+962',
      value: '962',
      flag: '🇯🇴',
      country: 'Jordânia',
    },
    {
      label: '+7',
      value: '7',
      flag: '🇰🇿',
      country: 'Cazaquistão',
    },
    {
      label: '+254',
      value: '254',
      flag: '🇰🇪',
      country: 'Quênia',
    },
    {
      label: '+686',
      value: '686',
      flag: '🇰🇮',
      country: 'Quiribati',
    },
    {
      label: '+383',
      value: '383',
      flag: '🇽🇰',
      country: 'Kosovo',
    },
    {
      label: '+965',
      value: '965',
      flag: '🇰🇼',
      country: 'Kuwait',
    },
    {
      label: '+996',
      value: '996',
      flag: '🇰🇬',
      country: 'Quirguistão',
    },
    {
      label: '+856',
      value: '856',
      flag: '🇱🇦',
      country: 'Laos',
    },
    {
      label: '+371',
      value: '371',
      flag: '🇱🇻',
      country: 'Letônia',
    },
    {
      label: '+961',
      value: '961',
      flag: '🇱🇧',
      country: 'Líbano',
    },
    {
      label: '+266',
      value: '266',
      flag: '🇱🇸',
      country: 'Lesoto',
    },
    {
      label: '+231',
      value: '231',
      flag: '🇱🇷',
      country: 'Libéria',
    },
    {
      label: '+218',
      value: '218',
      flag: '🇱🇾',
      country: 'Líbia',
    },
    {
      label: '+423',
      value: '423',
      flag: '🇱🇮',
      country: 'Liechtenstein',
    },
    {
      label: '+370',
      value: '370',
      flag: '🇱🇹',
      country: 'Lituânia',
    },
    {
      label: '+352',
      value: '352',
      flag: '🇱🇺',
      country: 'Luxemburgo',
    },
    {
      label: '+853',
      value: '853',
      flag: '🇲🇴',
      country: 'Macau',
    },
    {
      label: '+389',
      value: '389',
      flag: '🇲🇰',
      country: 'Macedônia do Norte',
    },
    {
      label: '+261',
      value: '261',
      flag: '🇲🇬',
      country: 'Madagascar',
    },
    {
      label: '+265',
      value: '265',
      flag: '🇲🇼',
      country: 'Malaui',
    },
    {
      label: '+60',
      value: '60',
      flag: '🇲🇾',
      country: 'Malásia',
    },
    {
      label: '+960',
      value: '960',
      flag: '🇲🇻',
      country: 'Maldivas',
    },
    {
      label: '+223',
      value: '223',
      flag: '🇲🇱',
      country: 'Mali',
    },
    {
      label: '+356',
      value: '356',
      flag: '🇲🇹',
      country: 'Malta',
    },
    {
      label: '+692',
      value: '692',
      flag: '🇲🇭',
      country: 'Ilhas Marshall',
    },
    {
      label: '+596',
      value: '596',
      flag: '🇲🇶',
      country: 'Martinica',
    },
    {
      label: '+222',
      value: '222',
      flag: '🇲🇷',
      country: 'Mauritânia',
    },
    {
      label: '+230',
      value: '230',
      flag: '🇲🇺',
      country: 'Maurícia',
    },
    {
      label: '+262',
      value: '262',
      flag: '🇾🇹',
      country: 'Maiote',
    },
    {
      label: '+52',
      value: '52',
      flag: '🇲🇽',
      country: 'México',
    },
    {
      label: '+691',
      value: '691',
      flag: '🇫🇲',
      country: 'Micronésia',
    },
    {
      label: '+373',
      value: '373',
      flag: '🇲🇩',
      country: 'Moldávia',
    },
    {
      label: '+377',
      value: '377',
      flag: '🇲🇨',
      country: 'Mônaco',
    },
    {
      label: '+976',
      value: '976',
      flag: '🇲🇳',
      country: 'Mongólia',
    },
    {
      label: '+382',
      value: '382',
      flag: '🇲🇪',
      country: 'Montenegro',
    },
    {
      label: '+1-664',
      value: '1664',
      flag: '🇲🇸',
      country: 'Montserrat',
    },
    {
      label: '+212',
      value: '212',
      flag: '🇲🇦',
      country: 'Marrocos',
    },
    {
      label: '+258',
      value: '258',
      flag: '🇲🇿',
      country: 'Moçambique',
    },
    {
      label: '+95',
      value: '95',
      flag: '🇲🇲',
      country: 'Mianmar',
    },
    {
      label: '+264',
      value: '264',
      flag: '🇳🇦',
      country: 'Namíbia',
    },
    {
      label: '+674',
      value: '674',
      flag: '🇳🇷',
      country: 'Nauru',
    },
    {
      label: '+977',
      value: '977',
      flag: '🇳🇵',
      country: 'Nepal',
    },
    {
      label: '+31',
      value: '31',
      flag: '🇳🇱',
      country: 'Holanda',
    },
    {
      label: '+599',
      value: '599',
      flag: '🇳🇱',
      country: 'Caribe Neerlandês',
    },
    {
      label: '+687',
      value: '687',
      flag: '🇳🇨',
      country: 'Nova Caledônia',
    },
    {
      label: '+64',
      value: '64',
      flag: '🇳🇿',
      country: 'Nova Zelândia',
    },
    {
      label: '+505',
      value: '505',
      flag: '🇳🇮',
      country: 'Nicarágua',
    },
    {
      label: '+227',
      value: '227',
      flag: '🇳🇪',
      country: 'Níger',
    },
    {
      label: '+234',
      value: '234',
      flag: '🇳🇬',
      country: 'Nigéria',
    },
    {
      label: '+683',
      value: '683',
      flag: '🇳🇺',
      country: 'Niue',
    },
    {
      label: '+672',
      value: '672',
      flag: '🇳🇫',
      country: 'Ilha Norfolk',
    },
    {
      label: '+850',
      value: '850',
      flag: '🇰🇵',
      country: 'Coreia do Norte',
    },
    {
      label: '+1-670',
      value: '1670',
      flag: '🇲🇵',
      country: 'Ilhas Marianas do Norte',
    },
    {
      label: '+47',
      value: '47',
      flag: '🇳🇴',
      country: 'Noruega',
    },
    {
      label: '+968',
      value: '968',
      flag: '🇴🇲',
      country: 'Omã',
    },
    {
      label: '+92',
      value: '92',
      flag: '🇵🇰',
      country: 'Paquistão',
    },
    {
      label: '+680',
      value: '680',
      flag: '🇵🇼',
      country: 'Palau',
    },
    {
      label: '+970',
      value: '970',
      flag: '🇵🇸',
      country: 'Palestina',
    },
    {
      label: '+507',
      value: '507',
      flag: '🇵🇦',
      country: 'Panamá',
    },
    {
      label: '+675',
      value: '675',
      flag: '🇵🇬',
      country: 'Papua Nova Guiné',
    },
    {
      label: '+595',
      value: '595',
      flag: '🇵🇾',
      country: 'Paraguai',
    },
    {
      label: '+51',
      value: '51',
      flag: '🇵🇪',
      country: 'Peru',
    },
    {
      label: '+63',
      value: '63',
      flag: '🇵🇭',
      country: 'Filipinas',
    },
    {
      label: '+48',
      value: '48',
      flag: '🇵🇱',
      country: 'Polônia',
    },
    {
      label: '+351',
      value: '351',
      flag: '🇵🇹',
      country: 'Portugal',
    },
    {
      label: '+1-787',
      value: '1787',
      flag: '🇵🇷',
      country: 'Porto Rico',
    },
    {
      label: '+974',
      value: '974',
      flag: '🇶🇦',
      country: 'Catar',
    },
    {
      label: '+242',
      value: '242',
      flag: '🇨🇬',
      country: 'República do Congo',
    },
    {
      label: '+262',
      value: '262',
      flag: '🇷🇪',
      country: 'Reunião',
    },
    {
      label: '+40',
      value: '40',
      flag: '🇷🇴',
      country: 'Romênia',
    },
    {
      label: '+7',
      value: '7',
      flag: '🇷🇺',
      country: 'Rússia',
    },
    {
      label: '+250',
      value: '250',
      flag: '🇷🇼',
      country: 'Ruanda',
    },
    {
      label: '+685',
      value: '685',
      flag: '🇼🇸',
      country: 'Samoa',
    },
    {
      label: '+378',
      value: '378',
      flag: '🇸🇲',
      country: 'San Marino',
    },
    {
      label: '+239',
      value: '239',
      flag: '🇸🇹',
      country: 'São Tomé e Príncipe',
    },
    {
      label: '+966',
      value: '966',
      flag: '🇸🇦',
      country: 'Arábia Saudita',
    },
    {
      label: '+221',
      value: '221',
      flag: '🇸🇳',
      country: 'Senegal',
    },
    {
      label: '+381',
      value: '381',
      flag: '🇷🇸',
      country: 'Sérvia',
    },
    {
      label: '+248',
      value: '248',
      flag: '🇸🇨',
      country: 'Seicheles',
    },
    {
      label: '+232',
      value: '232',
      flag: '🇸🇱',
      country: 'Serra Leoa',
    },
    {
      label: '+65',
      value: '65',
      flag: '🇸🇬',
      country: 'Singapura',
    },
    {
      label: '+421',
      value: '421',
      flag: '🇸🇰',
      country: 'Eslováquia',
    },
    {
      label: '+386',
      value: '386',
      flag: '🇸🇮',
      country: 'Eslovênia',
    },
    {
      label: '+677',
      value: '677',
      flag: '🇸🇧',
      country: 'Ilhas Salomão',
    },
    {
      label: '+252',
      value: '252',
      flag: '🇸🇴',
      country: 'Somália',
    },
    {
      label: '+27',
      value: '27',
      flag: '🇿🇦',
      country: 'África do Sul',
    },
    {
      label: '+82',
      value: '82',
      flag: '🇰🇷',
      country: 'Coreia do Sul',
    },
    {
      label: '+211',
      value: '211',
      flag: '🇸🇸',
      country: 'Sudão do Sul',
    },
    {
      label: '+34',
      value: '34',
      flag: '🇪🇸',
      country: 'Espanha',
    },
    {
      label: '+94',
      value: '94',
      flag: '🇱🇰',
      country: 'Sri Lanka',
    },
    {
      label: '+249',
      value: '249',
      flag: '🇸🇩',
      country: 'Sudão',
    },
    {
      label: '+597',
      value: '597',
      flag: '🇸🇷',
      country: 'Suriname',
    },
    {
      label: '+46',
      value: '46',
      flag: '🇸🇪',
      country: 'Suécia',
    },
    {
      label: '+41',
      value: '41',
      flag: '🇨🇭',
      country: 'Suíça',
    },
    {
      label: '+963',
      value: '963',
      flag: '🇸🇾',
      country: 'Síria',
    },
    {
      label: '+886',
      value: '886',
      flag: '🇹🇼',
      country: 'Taiwan',
    },
    {
      label: '+992',
      value: '992',
      flag: '🇹🇯',
      country: 'Tajiquistão',
    },
    {
      label: '+255',
      value: '255',
      flag: '🇹🇿',
      country: 'Tanzânia',
    },
    {
      label: '+66',
      value: '66',
      flag: '🇹🇭',
      country: 'Tailândia',
    },
    {
      label: '+670',
      value: '670',
      flag: '🇹🇱',
      country: 'Timor-Leste',
    },
    {
      label: '+228',
      value: '228',
      flag: '🇹🇬',
      country: 'Togo',
    },
    {
      label: '+690',
      value: '690',
      flag: '🇹🇰',
      country: 'Toquelau',
    },
    {
      label: '+676',
      value: '676',
      flag: '🇹🇴',
      country: 'Tonga',
    },
    {
      label: '+1-868',
      value: '1868',
      flag: '🇹🇹',
      country: 'Trindade e Tobago',
    },
    {
      label: '+216',
      value: '216',
      flag: '🇹🇳',
      country: 'Tunísia',
    },
    {
      label: '+90',
      value: '90',
      flag: '🇹🇷',
      country: 'Turquia',
    },
    {
      label: '+993',
      value: '993',
      flag: '🇹🇲',
      country: 'Turcomenistão',
    },
    {
      label: '+688',
      value: '688',
      flag: '🇹🇻',
      country: 'Tuvalu',
    },
    {
      label: '+256',
      value: '256',
      flag: '🇺🇬',
      country: 'Uganda',
    },
    {
      label: '+380',
      value: '380',
      flag: '🇺🇦',
      country: 'Ucrânia',
    },
    {
      label: '+971',
      value: '971',
      flag: '🇦🇪',
      country: 'Emirados Árabes Unidos',
    },
    {
      label: '+44',
      value: '44',
      flag: '🇬🇧',
      country: 'Reino Unido',
    },
    {
      label: '+598',
      value: '598',
      flag: '🇺🇾',
      country: 'Uruguai',
    },
    {
      label: '+998',
      value: '998',
      flag: '🇺🇿',
      country: 'Uzbequistão',
    },
    {
      label: '+678',
      value: '678',
      flag: '🇻🇺',
      country: 'Vanuatu',
    },
    {
      label: '+379',
      value: '379',
      flag: '🇻🇦',
      country: 'Cidade do Vaticano',
    },
    {
      label: '+58',
      value: '58',
      flag: '🇻🇪',
      country: 'Venezuela',
    },
    {
      label: '+84',
      value: '84',
      flag: '🇻🇳',
      country: 'Vietnã',
    },
    {
      label: '+681',
      value: '681',
      flag: '🇼🇫',
      country: 'Wallis e Futuna',
    },
    {
      label: '+967',
      value: '967',
      flag: '🇾🇪',
      country: 'Iémen',
    },
    {
      label: '+260',
      value: '260',
      flag: '🇿🇲',
      country: 'Zâmbia',
    },
    {
      label: '+263',
      value: '263',
      flag: '🇿🇼',
      country: 'Zimbábue',
    },
  ];
};
